import { Grid } from '@mui/material';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';

import WorkQueues from 'enums/workQueue.enum';
import { getOnboardedPatientsByPage } from 'store/thunks/workQueueThunks';
import { useWorkQueueTabSwitch } from '../contexts/WorkQueueTabSwitchContext';

import PatientQualificationTable from './PatientQualificationTable';
import PatientQualificationFilterButton from './PatientQualificationFilterButton';
import PatientQualificationFilterStatusBar from './PatientQualificationFilterStatusBar';

const PatientQualification = () => {
  const dispatch = useDispatch();
  const preset = useSelector(({ workQueue }) => workQueue.preset);
  const { currentPage } = useSelector(
    ({ workQueue }) => workQueue.patientQualification,
    shallowEqual
  );
  const { isTabSwitch } = useWorkQueueTabSwitch();

  useEffect(() => {
    if (isTabSwitch(WorkQueues.PATIENT_QUALIFICATION)) {
      dispatch(getOnboardedPatientsByPage({ page: currentPage }));
    }
  }, [dispatch, currentPage, isTabSwitch]);

  if (preset !== WorkQueues.PATIENT_QUALIFICATION) return null;

  return (
    <Grid container sx={{ py: 2 }}>
      <Grid item sx={{ minHeight: 40, flexGrow: 1 }} alignItems='center'>
        <PatientQualificationFilterStatusBar />
      </Grid>
      <Grid item>
        <PatientQualificationFilterButton />
      </Grid>
      <PatientQualificationTable />
    </Grid>
  );
};

export default PatientQualification;
